export enum AttributePartType {
  BASE_CODE = 'BaseCode',
  PRICING_GROUP = 'PricingGroup',
}
